import {
  ArrowDown,
  ArrowRight,
  ArrowUp,
  CheckCircle,
  CheckCircle2Icon,
  Circle,
  CircleOff,
  HelpCircle,
  LoaderIcon,
  Timer,
} from "lucide-react";

export const labels = [
  {
    value: "bug",
    label: "Bug",
  },
  {
    value: "feature",
    label: "Feature",
  },
  {
    value: "documentation",
    label: "Documentation",
  },
];

export const statuses = [
  // {
  //   value: "backlog",
  //   label: "Backlog",
  //   icon: HelpCircle,
  // },
  // {
  //   value: "todo",
  //   label: "Todo",
  //   icon: Circle,
  // },
  {
    value: "draft",
    label: "Draft",
    icon: LoaderIcon,
  },
  {
    value: "published",
    label: "Published",
    icon: CheckCircle2Icon,
  },
  // {
  //   value: "canceled",
  //   label: "Canceled",
  //   icon: CircleOff,
  // },
];

export const priorities = [
  {
    label: "Low",
    value: "low",
    icon: ArrowDown,
  },
  {
    label: "Medium",
    value: "medium",
    icon: ArrowRight,
  },
  {
    label: "High",
    value: "high",
    icon: ArrowUp,
  },
];

export const departmentsOptions = [
  { label: "Care Delivery", value: "Care Delivery" },
  {
    label: "Center for Equity, Diversity, and Inclusion",
    value: "Center for Equity, Diversity, and Inclusion",
  },
  { label: "Center for Global Impact", value: "Center for Global Impact" },
  {
    label: "Center for Integrity and Law",
    value: "Center for Integrity and Law",
  },
  { label: "CENTRA", value: "CENTRA" },
  { label: "Conquer Cancer", value: "Conquer Cancer" },
  { label: "Customer Service", value: "Customer Service" },
  {
    label: "Education, Science and Professional Development",
    value: "Education, Science and Professional Development",
  },
  { label: "Finance and Administration", value: "Finance and Administration" },
  { label: "Human Resources", value: "Human Resources" },
  { label: "Information Technology", value: "Information Technology" },
  {
    label: "Integrated Communications & Marketing",
    value: "Integrated Communications & Marketing",
  },
  { label: "Meeting Services", value: "Meeting Services" },
  { label: "Member Services", value: "Member Services" },
  {
    label: "Office of the Chief Digital Officer",
    value: "Office of the Chief Digital Officer",
  },
  {
    label: "Office of the Chief Executive Officer",
    value: "Office of the Chief Executive Officer",
  },
  { label: "Policy and Advocacy", value: "Policy and Advocacy" },
  { label: "Professional Development", value: "Professional Development" },
  { label: "Publishing", value: "Publishing" },
];

export const profilesOptions = [
  { label: "Associate", value: "Associate", level: 0 },
  { label: "Coordinator", value: "Coordinator", level: 1 },
  { label: "Administrator", value: "Administrator", level: 2 },
  { label: "Specialist", value: "Specialist", level: 3 },
  {
    label: "Manager (Individual Contributor)",
    value: "Manager (Individual Contributor)",
    level: 4,
  },
  { label: "Manager (Supervisory)", value: "Manager (Supervisory)", level: 5 },
  {
    label: "Senior Manager (Individual Contributor)",
    value: "Senior Manager (Individual Contributor)",
    level: 6,
  },
  {
    label: "Senior Manager (Supervisory)",
    value: "Senior Manager (Supervisory)",
    level: 7,
  },
  {
    label: "Associate Director (Individual Contributor)",
    value: "Associate Director (Individual Contributor)",
    level: 8,
  },
  {
    label: "Associate Director (Supervisory)",
    value: "Associate Director (Supervisory)",
    level: 9,
  },
  { label: "Director", value: "Director", level: 10 },
  { label: "Senior Director", value: "Senior Director", level: 11 },
  { label: "Division Director", value: "Division Director", level: 12 },
  { label: "Chief", value: "Chief", level: 13 },
  { label: "Vice President", value: "Vice President", level: 14 },
];

export const experienceOptions = [
  { label: "20 years", value: "20 years" },
  { label: "15 years", value: "15 years" },
  { label: "12 or 15 years", value: "12 or 15 years" },
  { label: "10 to 12 years", value: "10 to 12 years" },
  { label: "8 to 10 years", value: "8 to 10 years" },
  { label: "7 to 8 years", value: "7 to 8 years" },
  { label: "6 to 7 years", value: "6 to 7 years" },
  { label: "5 or 6 years", value: "5 or 6 years" },
  { label: "5 years", value: "5 years" },
  { label: "4 to 5 years", value: "4 to 5 years" },
  { label: "3 to 4 years", value: "3 to 4 years" },
  { label: "3 years", value: "3 years" },
  { label: "2 years", value: "2 years" },
  { label: "1 year", value: "1 year" },
];

export const educationOptions = [
  { label: "20 years", value: "20 years" },
  { label: "15 years", value: "15 years" },
  { label: "12 or 15 years", value: "12 or 15 years" },
  { label: "10 to 12 years", value: "10 to 12 years" },
  { label: "8 to 10 years", value: "8 to 10 years" },
  { label: "7 to 8 years", value: "7 to 8 years" },
  { label: "6 to 7 years", value: "6 to 7 years" },
  { label: "5 or 6 years", value: "5 or 6 years" },
  { label: "5 years", value: "5 years" },
  { label: "4 to 5 years", value: "4 to 5 years" },
  { label: "3 to 4 years", value: "3 to 4 years" },
  { label: "3 years", value: "3 years" },
  { label: "2 years", value: "2 years" },
  { label: "1 year", value: "1 year" },
];

export const workEnvironmentOptions = [
  {
    label: "Hybrid work location. Fast-paced office environment.",
    value: "Hybrid work location. Fast-paced office environment.",
  },
  {
    label:
      "Typically works in an office environment, but is regularly exposed to a non-routine work environment.",
    value:
      "Typically works in an office environment, but is regularly exposed to a non-routine work environment.",
  },
];

export const adaOptions = [
  {
    label: "Extended periods seated or standing at a desk",
    value: "Extended periods seated or standing at a desk",
  },
  {
    label: "High use of computer and other office technology equipment.",
    value: "High use of computer and other office technology equipment.",
  },
  {
    label:
      "Requires limited physical demands as standing, bending, walking and lifting small items.",
    value:
      "Requires limited physical demands as standing, bending, walking and lifting small items.",
  },
  {
    label:
      "Requires moderate physical demands as lifting up to 25 pounds and continuous standing.",
    value:
      "Requires moderate physical demands as lifting up to 25 pounds and continuous standing.",
  },
  {
    label: "Requires vigorous physical demands as lifting up to 50 pounds.",
    value: "Requires vigorous physical demands as lifting up to 50 pounds.",
  },
];

export const travelOptions = [
  { label: "No travel required.", value: "No travel required." },
  {
    label: "Minimal travel may be required (less than 5 days/year).",
    value: "Minimal travel may be required (less than 5 days/year).",
  },
  {
    label: "Occasional travel is required (less than 30 days per year).",
    value: "Occasional travel is required (less than 30 days per year).",
  },
  {
    label: "Regular travel is required (more than 30 days per year).",
    value: "Regular travel is required (more than 30 days per year).",
  },
  {
    label: "International travel is required.",
    value: "International travel is required.",
  },
];

export const jobFamilyOptions = [
  {
    label: "(0100) Accounting & Finance",
    value: "(0100) Accounting & Finance",
  },
  {
    label: "(0200) Administrative Operations",
    value: "(0200) Administrative Operations",
  },
  {
    label: "(0300) Research and Analytics",
    value: "(0300) Research and Analytics",
  },
  { label: "(0400) Communications", value: "(0400) Communications" },
  { label: "(0500) Customer Services", value: "(0500) Customer Services" },
  { label: "(0600) Creative Services", value: "(0600) Creative Services" },
  { label: "(0700) Editorial", value: "(0700) Editorial" },
  { label: "(0800) Education", value: "(0800) Education" },
  {
    label: "(0900) Foundation Management",
    value: "(0900) Foundation Management",
  },
  {
    label: "(1000) Government Relations",
    value: "(1000) Government Relations",
  },
  {
    label: "(1100) Health Informatics Technology",
    value: "(1100) Health Informatics Technology",
  },
  { label: "(1200) Human Resources", value: "(1200) Human Resources" },
  {
    label: "(1300) Information Technology",
    value: "(1300) Information Technology",
  },
  { label: "(1400) Legal", value: "(1400) Legal" },
  { label: "(1500) Marketing", value: "(1500) Marketing" },
  { label: "(1600) Meeting Planning", value: "(1600) Meeting Planning" },
  { label: "(1700) Membership", value: "(1700) Membership" },
  {
    label: "(1800) Practice Advancement",
    value: "(1800) Practice Advancement",
  },
  {
    label: "(2000) Relationship/Account Management",
    value: "(2000) Relationship/Account Management",
  },
  {
    label: "(2100) Senior Leadership Management",
    value: "(2100) Senior Leadership Management",
  },
];

export const profileLevelMap: Record<string, number> = {
  Associate: 0,
  Coordinator: 1,
  Administrator: 2,
  Specialist: 3,
  "Manager (Individual Contributor)": 4,
  "Manager (Supervisory)": 5,
  "Senior Manager (Individual Contributor)": 6,
  "Senior Manager (Supervisory)": 7,
  "Associate Director (Individual Contributor)": 8,
  "Associate Director (Supervisory)": 9,
  Director: 10,
  "Senior Director": 11,
  "Division Director": 12,
  Chief: 13,
  "Vice President": 14,
};

export const profileLevels = [
  { profile: "Associate", level: 0 },
  { profile: "Coordinator", level: 1 },
  { profile: "Administrator", level: 2 },
  { profile: "Specialist", level: 3 },
  { profile: "Manager (Individual Contributor)", level: 4 },
  { profile: "Manager (Supervisory)", level: 5 },
  { profile: "Senior Manager (Individual Contributor)", level: 6 },
  { profile: "Senior Manager (Supervisory)", level: 7 },
  { profile: "Associate Director (Individual Contributor)", level: 8 },
  { profile: "Associate Director (Supervisory)", level: 9 },
  { profile: "Director (Individual Contributor)", level: 10 },
  { profile: "Director (Supervisory)", level: 11 },
  { profile: "Senior Director", level: 12 },
  { profile: "Division Director", level: 13 },
  { profile: "Vice President", level: 14 },
];
